import useWeb3 from '../contexts/web3';
import useAlert from '../contexts/alert';
import { SetState } from '../interfaces/SetState';
import Web3 from 'web3';
import { contractABI, oneEther } from 'shared';
import fetcher from '../utils/fetcher';

type LoadingSetter = SetState<boolean>;
type Cb = (token: string) => any;

type SecretMint = (
  loadingSetter: LoadingSetter,
  token: string,
  price: number,
  code: string,
  onSuccess: Cb
) => void;

type Mint = (
  loadingSetter: LoadingSetter,
  token: string,
  price: number,
  onSuccess: Cb
) => void;

const useMint = (): { mint: Mint; secretMint: SecretMint } => {
  const alert = useAlert();
  const { connect, handleMetamaskClick } = useWeb3();

  const secretMint = (
    loadingSetter: LoadingSetter,
    token: string,
    price: number,
    code: string,
    onSuccess: Cb
  ) =>
    handleMetamaskClick(
      () => proceedWithMintClick(loadingSetter, token, price, onSuccess, code),
      'mint this dude'
    );

  const mint = (
    loadingSetter: LoadingSetter,
    token: string,
    price: number,
    onSuccess: Cb
  ) =>
    handleMetamaskClick(
      () => proceedWithMintClick(loadingSetter, token, price, onSuccess),
      'mint this dude'
    );

  const proceedWithMintClick = (
    setLoading: LoadingSetter,
    token: string,
    price: number,
    onSuccess: Cb,
    promoCode?: string
  ) => {
    setLoading(true);
    connect()
      .then((data) =>
        proceedWithMint(
          data.web3,
          data.publicAddress,
          setLoading,
          token,
          price,
          onSuccess,
          promoCode
        )
      )
      .catch((err) => {
        alert.showError(err);
        setLoading(false);
      });
  };

  const proceedWithMint = (
    web3: Web3,
    publicAddress: string,
    setLoading: LoadingSetter,
    token: string,
    price: number,
    onSuccess: Cb,
    promoCode?: string
  ) => {
    setLoading(true);
    const contract = new web3.eth.Contract(
      contractABI,
      process.env.REACT_APP_CONTRACT_ADDRESS
    );
    const data = {
      to: process.env.REACT_APP_CONTRACT_ADDRESS,
      from: publicAddress,
      value: String(price * oneEther)
    };
    const callback = (err: any, hash: string) => {
      if (err) {
        alert.showError(
          err?.message || "Can't mint NFT using metamask. Please try again"
        );
        setLoading(false);
      } else handleLocalMint(hash, token, setLoading, onSuccess);
    };
    if (promoCode) {
      contract.methods
        .secretMint(publicAddress, token, promoCode)
        .send(data, callback);
    } else {
      contract.methods.mint(publicAddress, token).send(data, callback);
    }
  };

  const handleLocalMint = (
    hash: string,
    nftToken: string,
    setLoading: LoadingSetter,
    onSuccess: Cb
  ) => {
    fetcher.nft
      .mint(hash, nftToken)
      .then(() => onSuccess(nftToken))
      .catch((err) => {
        alert.showError(err);
        setLoading(false);
      });
  };

  return { mint, secretMint };
};

export default useMint;
